exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._23qxKC0tmFEjYMhAaVNm_2{height:70px;width:70px}\n", ""]);

// Exports
exports.locals = {
	"gearImg": "_23qxKC0tmFEjYMhAaVNm_2"
};